import { Observable } from 'rxjs';
import { WidgetConfiguration, WidgetTypeId } from '@feature/widget-configs';
import { FormDefinition } from '@feature/_app_modules/dynamic-forms/dynamic-form';


export function isWidgetType(widgetTypeId: WidgetTypeId, t: WidgetConfiguration) {
  return t.widgetTypeId === widgetTypeId;
}

export interface WidgetAdminHandler {


  initialise(): boolean | Observable<boolean>;

  getAdminForm(selectedConfig: WidgetConfiguration): FormDefinition | Observable<FormDefinition>;

  /**
   * Creates a copy of the selectedConfig, updated with values from adminFormValue
   * calls back end services to persist the copy
   * @param adminFormValue due to how dynamic forms currently works adminFormValue gets passed in as any
   */
  createCopyFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean>;

  /**
   * Saves the selectedConfig, updated with values from adminFormValue
   * calls back end services to persist the copy
   * @param adminFormValue due to how dynamic forms currently works adminFormValue gets passed in as any
   */
  saveConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean>;

  deleteConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean>;

}

export interface WidgetAdminHandlerProvider {
  get(widgetTypeId: WidgetTypeId): WidgetAdminHandler;

  all(): Array<[WidgetTypeId, WidgetAdminHandler]>;

}
